// utils/formulas.js

// Example formula 1: High Final Values
export const calculateHighFinalValues = (fmv_high, a_high, b_high, c_high) => {
  return parseFloat(fmv_high) + parseFloat(a_high) + parseFloat(b_high) + parseFloat(c_high);
};

export const calculateALowValue = (fmv_high, a_high, fmv_low, isPriorLoss) => {
  const lowValue = parseFloat((fmv_low * a_high) / fmv_high);
  return isPriorLoss ? -Math.abs(lowValue) : lowValue; // Return as negative if Prior Loss
};

export const calculateBLowValue = (fmv_high, b_high, fmv_low, isPriorLoss) => {
  const lowValue = parseFloat((fmv_low * b_high) / fmv_high);
  return isPriorLoss ? -Math.abs(lowValue) : lowValue; // Return as negative if Prior Loss
};

export const calculateCLowValue = (fmv_high, c_high, fmv_low, isPriorLoss) => {
  const lowValue = parseFloat((fmv_low * c_high) / fmv_high);
  return isPriorLoss ? -Math.abs(lowValue) : lowValue; // Return as negative if Prior Loss
};


export const calculateLowFinalValues = (fmv_low, a_low, b_low, c_low) => {
  return parseFloat(fmv_low) + parseFloat(a_low) + parseFloat(b_low) + parseFloat(c_low);
};


// Calculate max loss range based on high and low final values
export const calculateMaxLossrange = (fmv_high, a_high, b_high, c_high, fmv_low, a_low, b_low, c_low) => {
  const highFinalValues = calculateHighFinalValues(fmv_high, a_high, b_high, c_high);
  const lowFinalValues = calculateLowFinalValues(fmv_low, a_low, b_low, c_low);
  return parseFloat(highFinalValues - lowFinalValues);
};

export const calculateLossThresold = (fmv_high, a_high, b_high, c_high) => {
  const highFinalValues = calculateHighFinalValues(fmv_high, a_high, b_high, c_high);
  return parseFloat(highFinalValues * 0.75);
};

export const calculateDamageToValue = (repairCost, finalHighValue) => {
  if (finalHighValue > 0) {
    return (repairCost / finalHighValue) * 10; // Return the damage to value as a percentage
  }
  return 0; // If finalHighValue is 0 or less, return 0 to avoid division by zero

};


export const calculateDamageSeverityScore = (laborHours, repairCost, damageToValue, structural, airbag) => {
  // Labor hours calculation

  let laborScore;
  if (laborHours > 80) {
    laborScore = 30;
  } else {
    laborScore = (laborHours * 30) / 100;
  }
  console.log("Labor Score:", laborScore);


  // Damage amount calculation
  let damageAmountScore;
  if (repairCost > 6500) {
    damageAmountScore = 15;
  } else {
    damageAmountScore = (repairCost * 15) / 7000;
  }
  console.log("Damage Amount Score:", damageAmountScore);

  // Damage to value calculation (using the logic you described)
  let damageToValueScore;
  if (damageToValue > 0.65) {
    damageToValueScore = 25;
  } else {
    damageToValueScore = damageToValue * 25;
  }
  console.log("Damage to Value Score:", damageToValueScore);

  // Structural score
  const structuralScore = structural ? 20 : 0;
  console.log("Structural Score:", structuralScore);

  // Airbag score
  const airbagScore = airbag ? 10 : 0;
  console.log("Airbag Score:", airbagScore);

  // Total damage severity score
  const totalScore = laborScore + damageAmountScore + damageToValueScore + structuralScore + airbagScore;
  console.log("Total Score:", totalScore);

  return totalScore;
};

export const calculateGrade = (value) => {
  let score;

  if (value < 20) {
    score = 1;
  } else if (value >= 20 && value < 40) {
    score = 2;
  } else if (value >= 40 && value < 60) {
    score = 3;
  } else if (value >= 60 && value < 80) {
    score = 4;
  } else if (value >= 80) {
    score = 5;
  }

  return score;
};

export const calculateInherentDV = (maxLossRange, damageSeverityScore) => {
  return (maxLossRange * damageSeverityScore) / 100;
};

export const calculatePostRepairFMV = (finalHighValue, inherentDV) => {
  return finalHighValue - inherentDV;
};

export const calculateDiminishedValue = (finalHighValue, postRepairFMV) => {
  return finalHighValue - postRepairFMV;
};

export const calculateMaxLossPercentage = (maxLossRange, highFinalValues) => {
  return maxLossRange / highFinalValues;
};